import { render, staticRenderFns } from "./IndicadoresHistoricoPlazosProveedores.vue?vue&type=template&id=b2ab4030&"
import script from "./IndicadoresHistoricoPlazosProveedores.vue?vue&type=script&lang=js&"
export * from "./IndicadoresHistoricoPlazosProveedores.vue?vue&type=script&lang=js&"
import style0 from "./IndicadoresHistoricoPlazosProveedores.vue?vue&type=style&index=0&id=b2ab4030&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports